import { capitalizeAfterComma, capitalizeFirstLetter, convertOldTableDataToNew, formatComment, isAdminEmail, truncateText } from '@utils/comman';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Tag, Popconfirm, Button, Space, Tooltip, Modal, Table, Dropdown, message } from 'antd';
import moment from 'moment';
import './index.css'
import { BankOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getOutstandingReferralsAction, getSuperAdminReferrersOutstanding, getReferralsByReferrerAction, updateReferralStatusAction, sendEmailToTheReferrerAction } from '../../../actions/refer';

function ListingCardReferrer({ data, index, isReferral, handleModal, handlEmailSent, handleSendEmailReminder, handleDeleteAdminReferrer, showViewMore = false, refetchData, isMyReferrers = false }: any) {
  const userData = useSelector((state: any) => state?.Auth?.user?.user || state?.Auth?.user?.data);
  const userRoleId = userData?.roleId;
  const [outstandingData, setOutstandingData] = useState([])
  const [outstandingLoading, setOutstandingLoading] = useState(false);
  const [referralData, setReferralData] = useState([])
  const [referralLoading, setReferralLoading] = useState(false);
  const [isReferralModalVisible, setIsReferralModalVisible] = useState(false);
  let isPayButton = (data?.businessCode === userData?.businessCode);
  let services = data?.rewards?.map((item:any)  => item?.offerName).join(', ')
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch()
  const user = data?.invite?.user;
  const fullName = `${user?.firstName ?? ''} ${user?.lastName ?? ''}`.trim();
  const invitedBy = fullName || user?.BusinessDetails?.businessName || '-';
  const invitedEmail = user?.email || '-';

  // Helper function to handle status updates
  const handleStatusUpdate = (newStatus: string, referralData: any) => {
    const payload = {
      referralId: referralData?.id,
      status: newStatus,
      ...(newStatus === 'contacted' && { contactedDate: new Date().toISOString() })
    };

    dispatch(updateReferralStatusAction(payload, (res: any) => {
      if (res?.success) {
        if (refetchData) {
          refetchData({});
        }
      }
    }));
  };
 const columns: any = [
    {
        title: 'First Name',
        dataIndex: 'firstName',
        key: 'firstName',
        render: (text: any) => <>{text}</>,
    },
    {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
        render: (text: any) => <>{text}</>,
    },
    {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        render: (text: any) => <>{text}</>,
    },
    {
        title: 'Mobile',
        dataIndex: 'mobileNumber',
        key: 'mobileNumber',
        render: (text: any) => <>{text}</>,
    },
    {
      title: 'Date Referred',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text: any) => <>{text && moment(text).format('DD/MM/YYYY')}</>,
  },
    {
        title: 'Contacted date',
        dataIndex: 'contactedDate',
        key: 'contactedDate',
        render: (text: any) => <>{text && moment(text).format('DD/MM/YYYY')}</>,
    }
];

  // Columns for referral data modal
  const referralColumns: any = [
    {
        title: 'Date Referred',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (text: any) => <>{text && moment(text).format('DD/MM/YYYY')}</>,
    },
    {
        title: 'First Name',
        dataIndex: 'firstName',
        key: 'firstName',
        render: (text: any) => <>{text || '-'}</>,
    },
    {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
        render: (text: any) => <>{text || '-'}</>,
    },
    {
        title: 'Contact Number',
        dataIndex: 'mobileNumber',
        key: 'mobileNumber',
        render: (text: any) => <>{text || '-'}</>,
    },
    {
        title: 'Mobile',
        dataIndex: 'mobileNumber',
        key: 'mobile',
        render: (text: any) => <>{text || '-'}</>,
    },
    {
        title: 'Email Address',
        dataIndex: 'email',
        key: 'email',
        render: (text: any) => <>{text || '-'}</>,
    },
    {
        title: 'Company',
        dataIndex: 'businessName',
        key: 'businessName',
        render: (text: any) => <>{text || '-'}</>,
    },
    {
        title: 'Category',
        dataIndex: 'services',
        key: 'services',
        render: (text: any) => <>{text || '-'}</>,
    },
    {
        title: 'Contacted date',
        dataIndex: 'contactedDate',
        key: 'contactedDate',
        render: (text: any) => <>{text ? moment(text).format('DD/MM/YYYY') : '-'}</>,
    },
    {
        title: 'Outcome',
        dataIndex: 'outcome',
        key: 'outcome',
        render: (text: any) => {
          let color = 'default';
          let displayText = text || 'pending';
          
          // Conditional rendering based on roleId
          if (userRoleId === 3) {
            // For roleId 3, show only acknowledged, successful, unsuccessful
            switch(text) {
              case 'acknowledged':
                color = 'orange';
                displayText = 'Acknowledged';
                break;
              case 'success':
              case true:
                color = 'green';
                displayText = 'Successful';
                break;
              case 'fail':
              case false:
                color = 'red';
                displayText = 'Unsuccessful';
                break;
              default:
                return null; // Don't show other outcomes for roleId 3
            }
          } else {
            // For other roles, show all outcomes
            switch(text) {
              case 'success':
              case true:
                color = 'green';
                displayText = 'Successful';
                break;
              case 'fail':
              case false:
                color = 'red';
                displayText = 'Un-Successful';
                break;
              case 'acknowledged':
                color = 'orange';
                displayText = 'Acknowledge';
                break;
              case 'contacted':
                color = 'blue';
                displayText = 'Contacted';
                break;
              case 'qualified':
                color = 'blue';
                displayText = 'Qualified';
                break;
              case 'not_a_fit':
                color = 'gray';
                displayText = 'Not a Fit';
                break;
              case 'customer_won':
                color = 'purple';
                displayText = 'Customer Won';
                break;
              default:
                color = 'orange';
                displayText = 'Pending';
            }
          }
          
          return <Tag color={color}>{displayText}</Tag>;
        },
    },
    {
        title: 'Paid Offer',
        dataIndex: 'paidOffer',
        key: 'paidOffer',
        render: (text: any) => <>{text || '$0.00'}</>,
    }
];


  if (userRoleId !== 1)  {
    columns.push({
      title: 'Paid Offer',
      dataIndex: 'paidOffer',
      key: 'paidOffer',
      render: (text: any) => <>{text}</>,
    })
  }



  const getOutstandingReferrals=(data: any)=> {
    let payload:any = { referrerId: data };
    setOutstandingLoading(true)
    if(userRoleId === 1){
      let saPayload = {
        adminId: data
      }
      dispatch(
        getSuperAdminReferrersOutstanding(saPayload, (resp: any) => {
              if (resp?.success) {
                  let formedData = convertOldTableDataToNew(resp?.data)
                  setOutstandingData(formedData);
                  setOutstandingLoading(false)
              }
          })
      );
    } else {
      dispatch(
        getOutstandingReferralsAction(payload, (resp: any) => {
              if (resp?.success) {
                  setOutstandingData(resp?.data);
                  setOutstandingLoading(false)
              }
          })
      );
    }
    setOutstandingLoading(false)
}
 
  const showModal = (data: any) => {
    setIsModalVisible(true);
    let adminId = userRoleId === 1 ? data?.adminId : data?.invite?.referrerId
    getOutstandingReferrals(adminId)
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const getReferralsByReferrer = (referrerId: any) => {
    setReferralLoading(true);
    dispatch(
      getReferralsByReferrerAction({ referrerId }, (resp: any) => {
        if (resp?.success) {
          setReferralData(resp?.data || []);
        } else {
          setReferralData([]);
        }
        setReferralLoading(false);
      })
    );
  };

  const showReferralModal = () => {
    setIsReferralModalVisible(true);
    const referrerId = data?.invite?.referrerId || data?.id;
    if (referrerId) {
      getReferralsByReferrer(referrerId);
    }
  };

  const handleReferralCancel = () => {
    setIsReferralModalVisible(false);
    setReferralData([]);
  };

  return (
    <div key={index}>
      <div className="feature-card">
        <div className="card-header1">
          {!isReferral ?
          <div>
            <div className="header-title-row">
              <h2 className="card-title1">{data?.invite?.firstName ?? data?.invite?.firstName} {data?.invite?.lastName ?? data?.invite?.lastName}</h2>
              {showViewMore && <Button type='default' className='view-more-btn' onClick={showReferralModal}>
                View More
              </Button>}
            </div>
            <div className='label-value'>
              <div>Mobile</div>
              <div className='list-Value'>
                {isAdminEmail(data?.email) ? "" : (data?.invite?.mobileNumber ?? data?.invite?.mobileNumber)}
              </div>
            </div>
            <div className='label-value'>
              <div>Email</div>
              <div className='list-Value text-break'>
                {isAdminEmail(data?.email) ? "" : (data?.invite?.email ?? data?.invite?.email)}
              </div>
            </div>
            <div className='label-value'>
              <div>Business Name</div>
              <div className='list-Value text-break'>
                {isAdminEmail(data?.invite?.email) ? "ReferUs Network" : (data?.invite?.referrerBusinessDetails?.businessName ?? data?.invite?.referrerBusinessDetails?.businessName)}
              </div>
            </div>

            <div className='label-value'>
              <div>No Of Referrals</div>
              <div className='list-Value'>{data?.referralsCount}</div>
            </div>
            <div className='label-value'>
              <div>Date Started</div>
              <div className='list-Value'>{data?.createdAt ? moment(data?.createdAt).format('DD/MM/YYYY') : ""}</div>
            </div>
              {userRoleId !== 1 &&
                <div className='label-value'>
                  <div>Last Date Of Referrals</div>
                  {/* <div className='list-Value'>{data?.invite?.user?.referrals?.length ? moment(data?.invite?.user?.referrals?.[0]?.createdAt).format('DD/MM/YYYY') : ""}</div> */}
                  <div className='list-Value'>{data?.invite?.lastReferralDateToMyBusiness ? moment(data?.invite?.lastReferralDateToMyBusiness).format('DD/MM/YYYY') : "-"}</div>
                </div>
              }
            <div className='label-value'>
              <div>Business Service</div>
              <div className='list-Value' style={{ marginLeft: '10px' }}>
                {isAdminEmail(data?.invite?.email) ? "Co-Founder" : <span title={data?.invite?.referrerBusinessDetails?.services}>{data?.invite?.referrerBusinessDetails?.services && (capitalizeFirstLetter(capitalizeAfterComma(data?.invite?.referrerBusinessDetails?.services)))}</span>}
              </div>
            </div>
          </div>
          : 
          <div>
            <div className="header-title-row">
              <h2 className="card-title1">{data?.firstName ?? data?.firstName} {data?.lastName ?? data?.lastName}</h2>
              {showViewMore && <Button type='default' className='view-more-btn' onClick={showReferralModal}>
                View More
              </Button>}
            </div>
            <div className='label-value'>
              <div>Mobile</div>
              <div className='list-Value'>
                {(data?.mobileNumber ?? data?.mobileNumber)}
              </div>
            </div>
            <div className='label-value'>
              <div>Email</div>
              <div className='list-Value text-break'>
                {(data?.email ?? data?.email)}
              </div>
            </div>
            <div className='label-value'>
              <div>Business Name</div>
              <div className='list-Value text-break'>
                {(data?.businessName ?? data?.businessName)}
              </div>
            </div>

            <div className='label-value'>
              <div>Referred By</div>
              <div className='list-Value'>
                { data?.sender?.contactName || `${data?.sender?.firstName ? data?.sender?.firstName : ''} ${data?.sender?.lastName ? data?.sender?.lastName : ''}`}
              </div>
            </div>
            <div className='label-value'>
              <div>Date Referred</div>
              <div className='list-Value'>{data?.createdAt ? moment(data?.createdAt).format('DD/MM/YYYY') : ""}</div>
            </div>
            <div className='label-value'>
              <div>Contacted Date</div>
              <div className='list-Value'>{data?.contactedDate && moment(data?.contactedDate).format('DD/MM/YYYY')}</div>
            </div>
            <div className='label-value'>
              <div>Services</div>
              <div className='list-Value' style={{ marginLeft: '10px' }}>
                {services}
              </div>
            </div>
            <div className='label-value'>
              <div>Contacted</div>
              <div className='list-Value'>
                {data?.hasSpoken === true ? 'Yes' : data?.hasSpoken === false ? 'No' : '-'}
              </div>
            </div>
              {/* {
                data?.comment?.length > 0 &&
             } */}
            <div className='label-value'>
                <div>Comments</div>
            <Tooltip title={data?.comment}>
              <div className='list-Value' style={{ marginLeft: '10px' }}>
                {data?.comment || '-'}
                {/* {formatComment(data?.comment) || ''} */}
              </div>
              </Tooltip>
            </div>
              
          </div>
          }
        </div>
        <div className='footer-wrapper'>
          <div className='card-service'>
            {!isReferral ?
              <div className="services-list">
                <div className='label-value'>
                  <div>Outstanding Payment</div>
                  <div className='ml-15' style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>{isAdminEmail(data?.invite?.email) ? "" : <>
                    {data?.outstanding > 0 && <Tag color='red' style={{ cursor: "pointer", textDecoration: "underLine" }} onClick={(e) => showModal(data)}>{data?.outstanding}</Tag>}
                    {data?.outstanding === 0 && <Tag color='green'>{data?.outstanding}</Tag>}
                    {/* Pay button for My Referrers - inline positioning */}
                    {isMyReferrers && (
                      <>
                        {userRoleId === 2 && (
                          <>
                            <Button type='default' disabled={!data?.outstanding} className='btn btn-outline-primary-md' onClick={() => handleModal({ show: true, data: data })}>
                              <BankOutlined /> Pay
                            </Button>
                            {!isAdminEmail(data?.invite?.email) && (
                              <Popconfirm
                                title="Are you sure you want to delete this referrer ?"
                                onConfirm={() => handleDeleteAdminReferrer(data)}
                                onCancel={() => console.log("Not sure")}
                                placement="top"
                              >
                                <DeleteOutlined style={{ color: 'rgb(244, 117, 35)', cursor: 'pointer', fontSize: '16px' }} />
                              </Popconfirm>
                            )}
                          </>
                        )}
                        {userRoleId === 1 && 
                        <Popconfirm title="Are you sure you want to mark it as paid?" onConfirm={() => handleModal({ show: true, data: data })} onCancel={()=>console.log("Cancelled!!")}>
                          <Button type='default' disabled={!data?.outstanding} className='btn btn-outline-primary-md'>
                            <BankOutlined /> Pay
                          </Button>
                        </Popconfirm>
                        }
                      </>
                    )}
                  </>}
                  </div>
                </div>
                {userRoleId !== 1 && <div className='label-value'>
                  <div>Total Income Referred</div>
                  <div className='ml-15 text-right font-weight-bold'>
                    {isAdminEmail(data?.invite?.email) ? "" : <>{data?.totalIncome}</>}</div>
                </div>
                }
                {userRoleId !== 1 && getStatusTagReferrer(data, handleSendEmailReminder)}
              </div>
              :
              <div className="services-list">
                {userRoleId !== 1 && <div className='label-value w-100'>
                  <div>Paid Offer</div>
                  <div className='ml-15'>{data?.paidOffer}
                  </div>
                  <div className="footer pt-0">
            {!isReferral ?
              <Space size="middle">
                {(userRoleId !== 3 && isAdminEmail(data?.invite?.email)) ? "" :
                  <Popconfirm
                    title={userRoleId === 2 ? `Are you sure you want to delete this referrer ?` : `Are you sure you want to delete this referrer? Once you click "OK," all data related to this referrer, including Business, Referrer, and Referral, will be permanently deleted from the system.`}
                    onConfirm={() => handleDeleteAdminReferrer(data)}
                    onCancel={() => console.log("Not sure")}
                    placement="top"
                    overlayStyle={{ width: 400 }}
                  >
                    <DeleteOutlined style={{ color: 'rgb(244, 117, 35)', cursor: 'pointer' }} />
                  </Popconfirm>
                }
              </Space>
              :
              <Space size="middle">
                {userRoleId === 3 &&
                  <Link to={'/view-referral'} state={{ isView: true, data, adminId: 1 }}>
                    <EyeOutlined style={{ fontSize: '18px', textAlign: 'right', marginLeft: '15px' }} />
                  </Link>}
                {/* Commented out - Pay button now appears in OutcomeTags after Sale is selected */}
                {/* {(userRoleId === 2 && isPayButton) &&
                  <Button type='default' disabled={data?.outcome === "success" || data?.outcome === true || data?.outcome === 'fail' || data?.outcome === false || data?.outcome === 'not_a_fit' || data?.outcome !== 'qualified'} className='btn btn-outline-primary-md' onClick={() => handleModal({ show: true, data: data })}>
                    <BankOutlined /> Pay
                  </Button>
                } */}
                {userRoleId === 1 && data?.outcome === "pending" &&
                <Button type='default' className='btn btn-outline-primary-md' onClick={() => handleModal({ show: true, data: data })}>
                  <BankOutlined /> Pay
                </Button>
                }
              </Space>
            }
          </div>
                </div>
                }
              {OutcomeTags(data, userRoleId, handlEmailSent, isPayButton, handleStatusUpdate, handleModal)}
            </div>
          }
          </div>
          </div>
        {(userRoleId === 2 && !isReferral) && (
          <>
            <div className='label-value'>
              <div>Invited By</div>
              <div className='list-Value text-break'>{invitedBy}</div>
            </div>
        
            <div className='label-value'>
              <div>Inviter Email</div>
              <div className='list-Value text-break'>{invitedEmail}</div>
            </div>
          </>
        )}
      </div>
       {/* Modal */}
       <Modal
        title="Outstanding Payments"
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null} // Optional: You can add custom footer buttons
        width={850}
      >
        <Table dataSource={outstandingData} loading={outstandingLoading} columns={columns} pagination={false} scroll={{ x: 700 }} />
      </Modal>

      {/* Referral Data Modal */}
      <Modal
        title="View Referrer"
        open={isReferralModalVisible}
        onCancel={handleReferralCancel}
        footer={null}
        width={1200}
      >
        <Table 
          dataSource={referralData} 
          loading={referralLoading} 
          columns={referralColumns} 
          pagination={false} 
          scroll={{ x: 1000 }}
          size="small"
        />
      </Modal>
    </div>
  );
}

export default ListingCardReferrer;

function getStatusTagReferrer(data: any, handleSendEmailReminder: any) {
    return (
        <div className="label-value">
            {data?.invite?.isRegistered ? (
                <Tag color="green">Active</Tag>
            ) : !data?.invite?.emailReminderSent ? (
                <Tooltip title="Send reminder email to the invited referrer">
                    <Popconfirm
                        title="Send email reminder"
                        onConfirm={() => handleSendEmailReminder(data)}
                    >
                        <Tag color="red" style={{ cursor: 'pointer' }}>
                            Invited
                        </Tag>
                    </Popconfirm>
                </Tooltip>
            ) : (
                <Tag color="red">Invited</Tag>
            )}
        </div>
    );
}

function OutcomeTags(data: any, userRoleId: any, handlEmailSent: any, isPayButton: any, handleStatusUpdate?: any, handleModal?: any) {
    // Get user data to check business codes and emails
    const userData = useSelector((state: any) => state?.Auth?.user?.user || state?.Auth?.user?.data);
    
    // Check if this is a cross-business referral for roleId 2
    const isCrossBusinessReferral = userRoleId === 2 && 
        data?.businessCode !== userData?.businessCode && 
        data?.sender?.email === userData?.email;
    
    // For roleId 2 cross-business referrals, show acknowledged and final successful/unsuccessful
    if (isCrossBusinessReferral) {
        const outcome = data?.outcome;

        // Treat these as "in progress" / acknowledged states where the left button stays highlighted
        const isAcknowledgedFlowState = (
            outcome === 'acknowledged' ||
            outcome === 'contacted' ||
            outcome === 'qualified' ||
            outcome === 'not_a_fit' ||
            outcome === 'success' ||
            outcome === true ||
            outcome === 'fail' ||
            outcome === false
        );

        const isSuccessful = outcome === 'success' || outcome === true;
        const isUnsuccessful = outcome === 'fail' || outcome === false || outcome === 'not_a_fit';
        
        return (
            <div className="label-value">
                <div>Outcome</div>
                <div className="ml-15 text-right font-weight-bold">
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '1fr 1fr', 
                        gap: '8px',
                        maxWidth: '400px',
                        marginLeft: 'auto',
                        gridAutoRows: '40px'
                    }}>
                        {/* Left: Acknowledged Button */}
                        <Button
                            block
                            disabled
                            type={isAcknowledgedFlowState ? 'primary' : 'default'}
                            style={{ 
                                backgroundColor: isAcknowledgedFlowState ? '#fa8c16' : undefined,
                                borderColor: isAcknowledgedFlowState ? '#fa8c16' : undefined,
                                color: isAcknowledgedFlowState ? 'white' : undefined,
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px',
                                opacity: 1
                            }}
                        >
                            Acknowledged
                        </Button>

                        {/* Right: Conditional button based on outcome */}
                        {isSuccessful ? (
                            <Button 
                                block
                                disabled
                                style={{ 
                                    backgroundColor: '#52c41a',
                                    borderColor: '#52c41a',
                                    color: 'white',
                                    height: '40px',
                                    minHeight: '40px',
                                    maxHeight: '40px',
                                    opacity: 1
                                }}
                            >
                                Successful
                            </Button>
                        ) : isUnsuccessful ? (
                            <Button 
                                block
                                disabled
                                style={{ 
                                    backgroundColor: '#ff4d4f',
                                    borderColor: '#ff4d4f',
                                    color: 'white',
                                    height: '40px',
                                    minHeight: '40px',
                                    maxHeight: '40px',
                                    opacity: 1
                                }}
                            >
                                Unsuccessful
                            </Button>
                        ) : (
                            <div></div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
    
    // For roleId 1, show simple Pending tag with Pay button or Successful tag
    if (userRoleId === 1) {
        const outcome = data?.outcome;
        
        if (outcome === 'success' || outcome === true) {
            return (
                <div className="label-value">
                    <div>Outcome</div>
                    <div className="ml-15 text-right font-weight-bold">
                        <Tag color='green' style={{ fontSize: '9px' }}>Successful</Tag>
                    </div>
                </div>
            );
        } else if (outcome === 'pending') {
            return (
                <div className="label-value">
                    <div>Outcome</div>
                    <div className="ml-15 text-right font-weight-bold" style={{ display: 'flex', alignItems: 'center', gap: '50px', justifyContent: 'flex-end' }}>
                        <Tag color='red' style={{ fontSize: '9px' }}>Pending</Tag>
                        <Popconfirm 
                            title="Are you sure you want to pay ?" 
                            onConfirm={() => handleModal({ show: true, data: data })} 
                            onCancel={() => console.log("Cancelled!!")}
                            okText="OK"
                            cancelText="Cancel"
                        >
                            <Button 
                                type='default' 
                                className='btn btn-outline-primary-md' 
                                style={{
                                    backgroundColor: '#ff7a00',
                                    borderColor: '#ff7a00',
                                    color: 'white',
                                    fontSize: '12px',
                                    height: '24px',
                                    padding: '0 8px'
                                }}
                            >
                                <BankOutlined /> Pay
                            </Button>
                        </Popconfirm>
                    </div>
                </div>
            );
        }
        
        return null;
    }
    
    // For roleId 3, use same grid design as roleId 2 but with conditional display
    if (userRoleId === 3) {
        const outcome = data?.outcome;
        
        return (
            <div className="label-value">
                <div>Outcome</div>
                <div className="ml-15 text-right font-weight-bold">
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '1fr 1fr', 
                        gap: '8px',
                        maxWidth: '400px',
                        marginLeft: 'auto',
                        gridAutoRows: '40px'
                    }}>
                        {/* Top Left: Acknowledged Button */}
                        <Button
                            block
                            type={(outcome === 'acknowledged' || outcome === 'contacted' || outcome === 'qualified' || outcome === 'success' || outcome === true || outcome === 'fail' || outcome === false || outcome === 'not_a_fit') ? 'primary' : 'default'}
                            style={{ 
                                backgroundColor: (outcome === 'acknowledged' || outcome === 'contacted' || outcome === 'qualified' || outcome === 'success' || outcome === true || outcome === 'fail' || outcome === false || outcome === 'not_a_fit') ? '#fa8c16' : undefined,
                                borderColor: (outcome === 'acknowledged' || outcome === 'contacted' || outcome === 'qualified' || outcome === 'success' || outcome === true || outcome === 'fail' || outcome === false || outcome === 'not_a_fit') ? '#fa8c16' : undefined,
                                color: (outcome === 'acknowledged' || outcome === 'contacted' || outcome === 'qualified' || outcome === 'success' || outcome === true || outcome === 'fail' || outcome === false || outcome === 'not_a_fit') ? 'white' : undefined,
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Acknowledged
                        </Button>

                        {/* Top Right: Conditional button based on outcome */}
                        {(outcome === 'success' || outcome === true) ? (
                            <Button 
                                block
                                style={{ 
                                    backgroundColor: '#52c41a',
                                    borderColor: '#52c41a',
                                    color: 'white',
                                    height: '40px',
                                    minHeight: '40px',
                                    maxHeight: '40px'
                                }}
                            >
                                Successful
                            </Button>
                        ) : (outcome === 'fail' || outcome === false || outcome === 'not_a_fit') ? (
                            <Button 
                                block
                                style={{ 
                                    backgroundColor: '#ff4d4f',
                                    borderColor: '#ff4d4f',
                                    color: 'white',
                                    height: '40px',
                                    minHeight: '40px',
                                    maxHeight: '40px'
                                }}
                            >
                                Unsuccessful
                            </Button>
                        ) : (
                            <div></div>
                        )}

                        {/* Bottom Left: Empty placeholder */}
                        <div></div>

                        {/* Bottom Right: Empty placeholder */}
                        <div></div>
                    </div>
                </div>
            </div>
        );
    }
    
    // For roleId 2 and other roles, keep existing logic
    // Handle final states - Successful
    if (data?.outcome === 'success' || data?.outcome === true) {
        return (
            <div className="label-value">
                <div>Outcome</div>
                <div className="ml-15 text-right font-weight-bold">
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '1fr 1fr', 
                        gap: '8px',
                        maxWidth: '400px',
                        marginLeft: 'auto',
                        gridAutoRows: '40px'
                    }}>
                        {/* Top Left: Acknowledge Button - Disabled */}
                        <Button
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Acknowledge
                        </Button>

                        {/* Top Right: Outcome Button - Disabled */}
                        <Button
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Outcome
                        </Button>

                        {/* Bottom Left: Contacted Button - Disabled */}
                        <Button
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Contacted
                        </Button>

                        {/* Bottom Right: Pay Button - Disabled */}
                        <Button 
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            <BankOutlined /> Pay
                        </Button>

                        {/* Successful Button - spans full width below grid */}
                        <div style={{ gridColumn: '1 / -1' }}>
                            <Button 
                                block
                                disabled
                                style={{ 
                                    backgroundColor: '#52c41a',
                                    borderColor: '#52c41a',
                                    color: 'white',
                                    height: '40px',
                                    minHeight: '40px',
                                    maxHeight: '40px'
                                }}
                            >
                                Successful
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Handle final states - Un-Successful (from Pay button)
    if (data?.outcome === 'fail' || data?.outcome === false) {
        return (
            <div className="label-value">
                <div>Outcome</div>
                <div className="ml-15 text-right font-weight-bold">
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '1fr 1fr', 
                        gap: '8px',
                        maxWidth: '400px',
                        marginLeft: 'auto',
                        gridAutoRows: '40px'
                    }}>
                        {/* Top Left: Acknowledge Button - Disabled */}
                        <Button
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Acknowledge
                        </Button>

                        {/* Top Right: Outcome Button - Disabled */}
                        <Button
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Outcome
                        </Button>

                        {/* Bottom Left: Contacted Button - Disabled */}
                        <Button
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Contacted
                        </Button>

                        {/* Bottom Right: Pay Button - Disabled */}
                        <Button 
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            <BankOutlined /> Pay
                        </Button>

                        {/* Un-Successful Button - spans full width below grid */}
                        <div style={{ gridColumn: '1 / -1' }}>
                            <Button 
                                block
                                disabled
                                style={{ 
                                    backgroundColor: '#ff4d4f',
                                    borderColor: '#ff4d4f',
                                    color: 'white',
                                    height: '40px',
                                    minHeight: '40px',
                                    maxHeight: '40px'
                                }}
                            >
                                Unsuccessful
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Handle final states - Not a Fit (from Outcome button)
    if (data?.outcome === 'not_a_fit') {
        return (
            <div className="label-value">
                <div>Outcome</div>
                <div className="ml-15 text-right font-weight-bold">
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '1fr 1fr', 
                        gap: '8px',
                        maxWidth: '400px',
                        marginLeft: 'auto',
                        gridAutoRows: '40px'
                    }}>
                        {/* Top Left: Acknowledge Button - Disabled */}
                        <Button
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Acknowledge
                        </Button>

                        {/* Top Right: Outcome Button - Disabled */}
                        <Button
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Outcome
                        </Button>

                        {/* Bottom Left: Contacted Button - Disabled */}
                        <Button
                            block
                            disabled
                            style={{ 
                                opacity: 0.5, 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Contacted
                        </Button>

                        {/* Not a Fit Button - bottom right position */}
                        <Button 
                            block
                            disabled
                            style={{ 
                                backgroundColor: '#8c8c8c',
                                borderColor: '#8c8c8c',
                                color: 'white',
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Not a Fit
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    if (data?.selfSend && data?.outcome === 'pending') {
        return (
            <div className="label-value">
                <div>Outcome</div>
                <div className="ml-15 text-right font-weight-bold">
                    <Tag color="yellow" style={{ fontSize: '9px' }}>Self Referral</Tag>
                </div>
            </div>
        );
    }

    if (data?.outcome === 'pending' && data?.isEmailSent) {
        return (
            <div className="label-value">
                <div>Outcome</div>
                <div className="ml-15 text-right font-weight-bold">
                    <Tag color="orange" style={{ fontSize: '9px' }}>Completed</Tag>
                </div>
            </div>
        );
    }

    // Determine current state for button workflow
    const currentOutcome = data?.outcome || 'pending';
    const canInteract = userRoleId === 2 && !data?.selfSend && isPayButton;

    // Define the workflow states
    const isPending = currentOutcome === 'pending';
    const isAcknowledged = currentOutcome === 'acknowledged';
    const isContacted = currentOutcome === 'contacted';
    const isQualified = currentOutcome === 'qualified';

    return (
        <div className="label-value">
            <div>Outcome</div>
            <div className="ml-15 text-right font-weight-bold">
                <div style={{ 
                    display: 'grid', 
                    gridTemplateColumns: '1fr 1fr', 
                    gap: '8px',
                    maxWidth: '400px',
                    marginLeft: 'auto',
                    gridAutoRows: '40px'
                }}>
                    {/* Top Left: Acknowledge Button */}
                    <Popconfirm
                        title="Acknowledge Referral?"
                        onConfirm={() => handleStatusUpdate && handleStatusUpdate('acknowledged', data)}
                        disabled={!canInteract || !isPending}
                    >
                        <Button
                            block
                            type={isPending ? 'primary' : 'default'}
                            disabled={!canInteract || !isPending}
                            style={{ 
                                backgroundColor: isPending ? '#1890ff' : undefined,
                                borderColor: isPending ? '#1890ff' : undefined,
                                opacity: !isPending && !canInteract ? 0.5 : 1,
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Acknowledge
                        </Button>
                    </Popconfirm>

                    {/* Top Right: Outcome Button - Opens Dropdown */}
                    {isContacted && canInteract ? (
                        <Dropdown
                            trigger={['click']}
                            dropdownRender={() => (
                                <div style={{ 
                                    background: 'white', 
                                    border: '1px solid #d9d9d9', 
                                    borderRadius: '6px', 
                                    padding: '12px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                                }}>
                                    <div style={{ marginBottom: '12px', fontSize: '14px', fontWeight: 500 }}>Choose Outcome:</div>
                                    <Space direction="vertical" style={{ width: '100%' }}>
                                        <Popconfirm
                                            title="Mark as Sale and enable payment?"
                                            onConfirm={() => handleStatusUpdate && handleStatusUpdate('qualified', data)}
                                        >
                                            <Button 
                                                type="primary" 
                                                block
                                            >
                                                Sale
                                            </Button>
                                        </Popconfirm>
                                        <Popconfirm
                                            title="Mark as Not a Fit?"
                                            onConfirm={() => handleStatusUpdate && handleStatusUpdate('not_a_fit', data)}
                                        >
                                            <Button 
                                                block
                                                danger
                                            >
                                                Not a Fit
                                            </Button>
                                        </Popconfirm>
                                    </Space>
                                </div>
                            )}
                        >
                            <Button
                                block
                                type="primary"
                                style={{ 
                                    height: '40px',
                                    minHeight: '40px',
                                    maxHeight: '40px'
                                }}
                            >
                                Outcome
                            </Button>
                        </Dropdown>
                    ) : (
                        <Button
                            block
                            disabled={!canInteract || !isContacted}
                            style={{ 
                                opacity: !isContacted && !canInteract ? 0.5 : 1,
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Outcome
                        </Button>
                    )}

                    {/* Bottom Left: Contacted Button */}
                    <Popconfirm
                        title="Mark as Contacted?"
                        onConfirm={() => handleStatusUpdate && handleStatusUpdate('contacted', data)}
                        disabled={!canInteract || !isAcknowledged}
                    >
                        <Button
                            block
                            type={isAcknowledged ? 'primary' : 'default'}
                            disabled={!canInteract || !isAcknowledged}
                            style={{ 
                                backgroundColor: isAcknowledged ? '#1890ff' : undefined,
                                borderColor: isAcknowledged ? '#1890ff' : undefined,
                                opacity: !isAcknowledged && !canInteract ? 0.5 : 1,
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            Contacted
                        </Button>
                    </Popconfirm>

                    {/* Bottom Right: Pay Button - Only shows when Sale is selected */}
                    {isQualified && (
                        <Button 
                            block
                            type='default' 
                            className='btn btn-outline-primary-md' 
                            onClick={() => handleModal && handleModal({ show: true, data: data })}
                            style={{ 
                                height: '40px',
                                minHeight: '40px',
                                maxHeight: '40px'
                            }}
                        >
                            <BankOutlined /> Pay
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}

